export default [{
    path: '/publicPage/earlyWarning',
    name: 'earlyWarning',
    component: () => import( /* webpackChunkName: "common" */ './earlyWarning.vue'),
    meta: {
        authPass: true,
        title: '发货订金提升预警设置',
        noTitle: true,
        headerId: 'myFortune'
    }
}];